import React from "react";

/**
 * Animated streak flame that grows + colour-shifts with streak length.
 * Tiers: spark (0-2), ember (3-6), flame (7-29), inferno (30+).
 */
export default function FireStreak({ days = 0, size = 38 }) {
  const tier =
    days >= 30 ? "inferno" : days >= 7 ? "flame" : days >= 3 ? "ember" : "spark";

  const palette = {
    spark:   { outer: "#94a3b8", inner: "#cbd5e1", hot: "#f1f5f9", glow: "rgba(148,163,184,0.35)" },
    ember:   { outer: "#f97316", inner: "#fbbf24", hot: "#fde68a", glow: "rgba(249,115,22,0.45)" },
    flame:   { outer: "#ef4444", inner: "#f97316", hot: "#fde047", glow: "rgba(239,68,68,0.55)" },
    inferno: { outer: "#a855f7", inner: "#ef4444", hot: "#fde047", glow: "rgba(168,85,247,0.6)" },
  }[tier];

  const uid = React.useId();
  return (
    <div
      className="relative inline-flex items-center justify-center"
      style={{
        width: size,
        height: size,
        filter: `drop-shadow(0 0 ${size * 0.35}px ${palette.glow})`,
      }}
      data-testid="fire-streak"
      data-tier={tier}
    >
      <svg
        viewBox="0 0 64 96"
        width={size}
        height={size * 1.45}
        className="ps-flicker"
        style={{ transformOrigin: "center bottom" }}
      >
        <defs>
          <radialGradient id={`fg-outer-${uid}`} cx="50%" cy="65%" r="55%">
            <stop offset="0%" stopColor={palette.hot} />
            <stop offset="55%" stopColor={palette.inner} />
            <stop offset="100%" stopColor={palette.outer} stopOpacity="0.95" />
          </radialGradient>
          <radialGradient id={`fg-inner-${uid}`} cx="50%" cy="80%" r="40%">
            <stop offset="0%" stopColor="#fffbeb" />
            <stop offset="100%" stopColor={palette.hot} stopOpacity="0" />
          </radialGradient>
        </defs>
        {/* outer flame */}
        <path
          d="M32 90
             C 10 78, 8 56, 22 42
             C 26 50, 30 50, 30 42
             C 30 28, 22 22, 28 8
             C 36 18, 44 24, 46 42
             C 50 38, 54 44, 54 54
             C 54 78, 50 86, 32 90 Z"
          fill={`url(#fg-outer-${uid})`}
        />
        {/* inner hot core */}
        <path
          d="M32 86
             C 22 80, 20 66, 28 56
             C 30 62, 34 60, 34 52
             C 34 44, 32 38, 36 30
             C 42 38, 46 48, 46 60
             C 46 78, 42 84, 32 86 Z"
          fill={`url(#fg-inner-${uid})`}
        />
      </svg>
      {/* days badge */}
      <div
        className="absolute -bottom-1 left-1/2 -translate-x-1/2 px-1.5 py-0.5 rounded-full bg-[#050E15]/85 border border-[#1B364A] text-[9px] font-extrabold ps-tabular leading-none"
        style={{ color: palette.hot, textShadow: `0 0 6px ${palette.glow}` }}
      >
        {days}d
      </div>
    </div>
  );
}
